import axios from "axios";

const backendUrlDelete = process.env.REACT_APP_BACKEND_RESUME_DELETE_BY_ID_URL;

const DeleteResume = async (id, token) => {
  const deleteUrl = `${backendUrlDelete}/${id}`;
  try {
    const response = await axios.delete(deleteUrl, {
      headers: { token: token },
    });
    return response;
  } catch (err) {
    // Re-lanza el error para que la función que llama pueda manejarlo.
    throw err;
  }
};

export default DeleteResume;
